import { ErrorObject } from '@qpr/client-library/dist/esm/ErrorContext';

export interface CanvasCellState {
  id: string;
  name: string;
  rows: CellRowState[];
  parentId?: string;
}

export interface CellRowState {
  id: string;
  name: string;
  rangecolor?: string;
  groupId?: string;
  measureId?: string;
  sipocViewId?: string;
}

export interface BusinessModelCanvasState {
  elements: CanvasCellState[];
  error: ErrorObject;
}

const elements: CanvasCellState[] = [
  { id: '1', name: 'Key Partners', rows: [] as CellRowState[] },
  { id: '2', name: 'Key Activities', rows: [] as CellRowState[] },
  { id: '3', name: 'Key Resources', rows: [] as CellRowState[] },
  { id: '4', name: 'Value Propositions', rows: [] as CellRowState[] },
  { id: '5', name: 'Customer Relationships', rows: [] as CellRowState[] },
  { id: '6', name: 'Channels', rows: [] as CellRowState[] },
  { id: '7', name: 'Customer Segments', rows: [] as CellRowState[] },
  { id: '8', name: 'Cost Structure', rows: [] as CellRowState[] },
  { id: '9', name: 'Revenue Streams', rows: [] as CellRowState[] }
];

const initialState = { elements, error: { message: '', details: '' } } as BusinessModelCanvasState;
export default initialState;
